var render = function () {
  var _vm$startup, _vm$startup$thumb, _vm$startup2, _vm$startup6, _vm$startup8, _vm$startup9, _vm$startup10;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', {
    scopedSlots: _vm._u([{
      key: "subHead",
      fn: function fn() {
        return [_c('sub-visual', {
          attrs: {
            "text": "디지털유통 혁신을 함께할 기술 스타트업을 찾습니다.",
            "src": "/images/sub/sub-visual-pitching-festa.jpg"
          },
          scopedSlots: _vm._u([{
            key: "titleContents",
            fn: function fn() {
              return [_c('div', {
                staticClass: "sub-visual__tit-wrap mt-n20px"
              }, [_c('h2', {
                staticClass: "sub-visual__tit"
              }, [_c('span', {
                staticClass: "font-size-lg-100 font-weight-bold"
              }, [_vm._v("e")]), _vm._v("커머스피칭페스타 지원")])])];
            },
            proxy: true
          }])
        })];
      },
      proxy: true
    }])
  }, [_c('page-section', {
    staticClass: "page-section--first py-30px py-md-40px"
  }, [_c('v-row', {
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "auto",
      "data-aos": "fade-right",
      "data-aos-delay": "100"
    }
  }, [_c('v-card', {
    staticClass: "border-light mx-auto",
    attrs: {
      "outlined": "",
      "width": "150"
    }
  }, [_c('v-img', {
    attrs: {
      "width": "100%",
      "aspect-ratio": 150 / 150,
      "src": (_vm$startup = _vm.startup) === null || _vm$startup === void 0 ? void 0 : (_vm$startup$thumb = _vm$startup.thumb) === null || _vm$startup$thumb === void 0 ? void 0 : _vm$startup$thumb.src
    }
  })], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "",
      "data-aos": "fade-left",
      "data-aos-delay": "100"
    }
  }, [_c('card-board', {
    staticClass: "border-0",
    attrs: {
      "chip": (_vm$startup2 = _vm.startup) === null || _vm$startup2 === void 0 ? void 0 : _vm$startup2.awardName
    },
    scopedSlots: _vm._u([{
      key: "titleSlot",
      fn: function fn() {
        var _vm$startup3;
        return [_c('div', {
          staticClass: "tit tit--xs mt-n4px"
        }, [_vm._v(_vm._s((_vm$startup3 = _vm.startup) === null || _vm$startup3 === void 0 ? void 0 : _vm$startup3.name))])];
      },
      proxy: true
    }, {
      key: "textSlot",
      fn: function fn() {
        var _vm$startup4;
        return [_c('p', {
          staticClass: "txt txt--lg txt--dark mt-6px"
        }, [_vm._v(_vm._s((_vm$startup4 = _vm.startup) === null || _vm$startup4 === void 0 ? void 0 : _vm$startup4.description))])];
      },
      proxy: true
    }, {
      key: "hash",
      fn: function fn() {
        var _vm$startup5;
        return [_c('div', {
          staticClass: "mt-16px mt-md-24px"
        }, [_c('v-row', {
          staticClass: "row--xs"
        }, _vm._l((_vm$startup5 = _vm.startup) === null || _vm$startup5 === void 0 ? void 0 : _vm$startup5.hashTags, function (hashTag, index) {
          return _c('v-col', {
            key: index,
            attrs: {
              "cols": "auto"
            }
          }, [_c('span', {
            staticClass: "txt txt--xs primary--text"
          }, [_vm._v("#" + _vm._s(hashTag))])]);
        }), 1)], 1)];
      },
      proxy: true
    }])
  })], 1)], 1)], 1), _c('page-section', {
    staticClass: "page-section--last pt-30px pt-md-40px grey lighten-5"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "4",
      "order-lg": "2",
      "data-aos": "fade-up",
      "data-aos-delay": "200"
    }
  }, [_c('v-card', {
    attrs: {
      "color": "white"
    }
  }, [_c('div', {
    staticClass: "pa-20px pa-md-30px px-lg-24px py-lg-40px"
  }, [_c('div', {
    staticClass: "mb-10px"
  }, [_c('h3', {
    staticClass: "tit tit--xxs"
  }, [_vm._v("회사정보")])]), _vm._l((_vm$startup6 = _vm.startup) === null || _vm$startup6 === void 0 ? void 0 : _vm$startup6.information, function (information, index) {
    var _information$txt, _vm$startup7, _vm$startup7$informat;
    return _c('div', {
      key: index
    }, [_c('v-row', {
      staticClass: "row--sm"
    }, [_c('v-col', {
      attrs: {
        "cols": "auto"
      }
    }, [_c('div', {
      staticClass: "txt txt--sm txt--dark w-100px"
    }, [_vm._v(_vm._s(information === null || information === void 0 ? void 0 : information.title))])]), _c('v-col', [_c('div', {
      staticClass: "txt txt--sm",
      domProps: {
        "innerHTML": _vm._s(information === null || information === void 0 ? void 0 : (_information$txt = information.txt) === null || _information$txt === void 0 ? void 0 : _information$txt.replace(/\n/g, '<br>'))
      }
    }), ((_vm$startup7 = _vm.startup) === null || _vm$startup7 === void 0 ? void 0 : (_vm$startup7$informat = _vm$startup7.information) === null || _vm$startup7$informat === void 0 ? void 0 : _vm$startup7$informat.length) === index + 1 ? _c('div', {
      staticClass: "mt-10px"
    }, [_c('v-btn', {
      staticClass: "min-w-220px justify-space-between",
      attrs: {
        "x-large": "",
        "color": "secondary",
        "href": _vm.startup.link
      }
    }, [_vm._v(" 웹사이트 바로가기 "), _c('icon-arrow-rounded', {
      staticClass: "icon--size-small ml-12px",
      attrs: {
        "direction": "right"
      }
    })], 1)], 1) : _vm._e()])], 1)], 1);
  }), _c('v-divider', {
    staticClass: "my-16px my-md-24px"
  }), _vm._l((_vm$startup8 = _vm.startup) === null || _vm$startup8 === void 0 ? void 0 : _vm$startup8.helpItems, function (item, index) {
    var _item$txt;
    return _c('div', {
      key: index,
      class: index !== 0 ? 'mt-16px mt-md-24px' : ''
    }, [_c('div', {
      staticClass: "mb-10px"
    }, [_c('h3', {
      staticClass: "tit tit--xxs"
    }, [_vm._v(_vm._s(item === null || item === void 0 ? void 0 : item.title))])]), _c('div', {
      staticClass: "txt txt--sm",
      domProps: {
        "innerHTML": _vm._s(item === null || item === void 0 ? void 0 : (_item$txt = item.txt) === null || _item$txt === void 0 ? void 0 : _item$txt.replace(/\n/g, '<br>'))
      }
    })]);
  })], 2)])], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "8",
      "order-lg": "1",
      "data-aos": "fade-up",
      "data-aos-delay": "100"
    }
  }, [_c('v-card', {
    attrs: {
      "color": "white"
    }
  }, [_c('div', {
    staticClass: "pa-20px pa-md-30px pa-lg-40px"
  }, [_vm._l((_vm$startup9 = _vm.startup) === null || _vm$startup9 === void 0 ? void 0 : _vm$startup9.items, function (item, index) {
    var _item$txt2;
    return _c('div', {
      key: index,
      class: index !== 0 ? 'mt-16px mt-md-24px' : ''
    }, [_c('div', {
      staticClass: "mb-10px"
    }, [_c('h3', {
      staticClass: "tit tit--xxs"
    }, [_vm._v(_vm._s(item === null || item === void 0 ? void 0 : item.title))])]), _c('div', {
      staticClass: "txt txt--sm",
      domProps: {
        "innerHTML": _vm._s(item === null || item === void 0 ? void 0 : (_item$txt2 = item.txt) === null || _item$txt2 === void 0 ? void 0 : _item$txt2.replace(/\n/g, '<br>'))
      }
    })]);
  }), _vm._l((_vm$startup10 = _vm.startup) === null || _vm$startup10 === void 0 ? void 0 : _vm$startup10.youtubeLink, function (youtubeLink, index) {
    return _c('div', {
      key: index,
      staticClass: "mt-16px mt-md-24px"
    }, [_c('v-responsive', {
      attrs: {
        "aspect-ratio": 560 / 315
      }
    }, [_c('iframe', {
      attrs: {
        "width": "100%",
        "height": "100%",
        "src": _vm.convertYouTubeURL(youtubeLink.title),
        "title": "YouTube video player",
        "frameborder": "0",
        "allow": "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share",
        "allowfullscreen": ""
      }
    })])], 1);
  })], 2)])], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }